import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

const FIVE_MINUTES = 5 * 60 * 1000

const GET_PRICING_EXPERIMENTS_QUERY = gql`
  query getPricingExperiments {
    getPricingExperiments {
      campaignId
      pricingGroups
    }
  }
`

export interface PricingExperiment {
  campaignId: string
  pricingGroups: string[]
}

interface GetPricingExperimentsResponse {
  getPricingExperiments: PricingExperiment[]
}

export const usePricingExperimentsApi = (): UseQueryResult<PricingExperiment[], Error> => {
  const client = useGraphQLClient()

  const fetchPricingExperiments = async (): Promise<PricingExperiment[]> => {
    const data = await client.request<GetPricingExperimentsResponse>(GET_PRICING_EXPERIMENTS_QUERY)

    return data.getPricingExperiments
  }

  return useQuery<PricingExperiment[], Error>({
    queryKey: ['pricing-experiments'],
    queryFn: fetchPricingExperiments,
    staleTime: FIVE_MINUTES,
    gcTime: FIVE_MINUTES,
  })
}

export default usePricingExperimentsApi
